export default __webpack_public_path__ + "static/media/5503.6bf66ebe.png";